import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksAccountLineItemsSection', {
    actionCloneLine: 'Clone a line',
    actionRemoveLine: 'Remove a line',
    colNameAccount: 'Category',
    colNameDescription: 'Description',
    colNameAmount: 'Amount',
    colNameLinked: 'Linked',
    colNameTaxCode: 'Tax',
    colNameCustomer: 'Customer',
    colNameClass: 'Class',
    colNameIsBillable: 'Billable',
    colNameIsTaxable: 'Tax',
    cellPlaceholderAccount: 'Select category',
    cellPlaceholderDescription: 'Enter a description',
    cellPlaceholderAmount: 'Enter the amount',
    cellPlaceholderTaxCode: 'Select Tax code',
    cellPlaceholderCustomer: 'Select a Customer',
    cellPlaceholderClass: 'Select a Class',
    addLine: 'Add line',
});
